export class BadRequestException extends Error {
  constructor(message = 'Bad request') {
    super(message);
  }
}
